import {useEffect, useRef, useState} from "react"
import ReactTooltip from "react-tooltip"

export function useEllipsisCheck(text: string) {
	const textRef = useRef<HTMLDivElement>(null)
	const [isTruncated, setIsTruncated] = useState(false)

	useEffect(() => {
		const checkEllipsis = () => {
			if (textRef.current) {
				const {offsetWidth, scrollWidth} = textRef.current
				setIsTruncated(scrollWidth > offsetWidth)
			}
		}

		checkEllipsis() // Initial check

		// Use ResizeObserver for real-time updates
		const observer = new ResizeObserver(checkEllipsis)
		if (textRef.current) {
			observer.observe(textRef.current)
		}

		return () => {
			observer.disconnect()
		}
	}, [text])

	useEffect(() => {
		ReactTooltip.rebuild() // Rebuild tooltip when truncation state changes
	}, [isTruncated])

	return {textRef, isTruncated}
}
